import { render } from "./SectionKontakt.vue?vue&type=template&id=fdc7b2f0&scoped=true"
const script = {}

import "./SectionKontakt.vue?vue&type=style&index=0&id=fdc7b2f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdc7b2f0"]])

export default __exports__